<template>
    <div class="flex flex-col gap-y-18.5 pt-17.5 pb-16">
        <LocationMenuSection v-for="section in menu.sections" v-bind="section" :key="`menu-section-${section.id}`" />
    </div>
</template>

<script setup>
import LocationMenuSection from './LocationMenuSection.vue';

defineProps({ menu: { type: Object, default: () => ({}) } });
</script>
